import {t} from 'i18next';
import {useNavigate} from 'react-router-dom';
import {useBookingState} from '../store';
import PersonInfo from '../components/PersonInfo';
import {BreakpointMinWidth, Language, RoutePath} from '../lib/enums';
import {formatDateToReadableString} from '../helpers';
import ConfirmBooking from '../components/CreateBooking';
import AbortBooking from '../components/AbortBooking';
import {isContactDetailsInvalidated} from '../helpers/validations';
import {useEffect} from 'react';
import {useWindowSize} from '@uidotdev/usehooks';
import {UaBreadcrumbs, UaButton} from 'uppsala.ui.react';

const ReviewPage = () => {
  const navigate = useNavigate();
  const state = useBookingState((state) => state);
  const size = useWindowSize();
  const isSmallScreen = size.width && size.width < BreakpointMinWidth.sm;

  const headerMarginTop = '55px';

  useEffect(() => {
    if (isContactDetailsInvalidated(state.person1, state.person2, state.validationFields)) {
      navigate(-1);
    }
  }, []);

  return (
    <div style={{maxWidth: '500px'}}>
      <UaBreadcrumbs onClick={(linkItem) => navigate(linkItem.href)} />
      <h1>{t('booking.header.compilation')}</h1>

      <h2 style={{marginTop: '30px'}}>{t('booking.time')}</h2>

      <div
        style={{
          display: 'flex',
          flexDirection: size.width && isSmallScreen ? 'column' : 'row',
          justifyContent: 'space-between',
        }}>
        <div style={{width: '180px'}}>
          <p>{formatDateToReadableString(new Date(state.weddingOccasionTime))}</p>
        </div>
        <UaButton
          style={{marginTop: isSmallScreen ? '25px' : '0', marginLeft: isSmallScreen ? '0' : '50px'}}
          title={t('button.modify')}
          onClick={() =>
            state.isCustomOccasion ? navigate(RoutePath.CustomBookingPage) : navigate(RoutePath.HomePage)
          }
        />
      </div>

      <h2 style={{marginTop: headerMarginTop}}>{t('booking.location')}</h2>
      <p>{state.location}</p>
      <h2 style={{marginTop: headerMarginTop}}>{t('booking.weddingOfficiant')}</h2>
      <p>{state.weddingOfficiant}</p>

      <h2 style={{marginTop: headerMarginTop}}>{t('booking.who')}</h2>
      <div style={{display: 'flex', flexDirection: isSmallScreen ? 'column' : 'row', justifyContent: 'space-between'}}>
        <div style={{wordBreak: 'break-word'}}>
          <PersonInfo person={state.person1} />
          <PersonInfo person={state.person2} style={{marginTop: '10px'}} />
        </div>
        <div style={{margin: isSmallScreen ? '25px 0 0 0' : '0 0 0 10px'}}>
          <UaButton title={t('button.modify')} onClick={() => navigate(-1)} />
        </div>
      </div>

      <h2 style={{marginTop: headerMarginTop}}>{t('booking.ceremonyLanguage')}</h2>
      <p>{state.ceremonyLanguage === Language.Swedish ? 'Svenska' : 'Engelska'}</p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '15px',
          marginTop: headerMarginTop,
          flexWrap: size.width && size.width < BreakpointMinWidth.xs ? 'wrap-reverse' : 'nowrap',
        }}>
        <AbortBooking />
        <ConfirmBooking />
      </div>
    </div>
  );
};

export default ReviewPage;
